module.exports = __webpack_public_path__ + "media/images/subject_img/ACTUARIAL SCIENCE-52d5ace520ca94ec554d80a9d251f85c.jpg";